// extracted by mini-css-extract-plugin
module.exports = {"playerselectorModal":"_95adb98","flexFull":"_00de712","desktopEmbedded":"_8089734","mobileDevice":"_f899140","flexFullFit":"_acef024","gameInfo":"_866c222","gamePicker":"_82b5c96"};